import { makeStyles, Paper, Tab, Table, TableBody, TableCell, TableContainer, TableRow, Tabs, Typography } from "@material-ui/core"
import React, { useState } from "react"
import { TabPanel } from "./App"

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        display: 'flex',
        height: '100%',
    },
    table: {
        maxWidth: 900,
    },
    tabs: {
        borderRight: `1px solid ${theme.palette.divider}`,
    },
}))

export const Enotites = () => {
    const classes = useStyles()
    const [activeTab, setActiveTab] = useState(0)

    return (
        <React.Fragment>
            <Typography variant='h5'>Ενότητες</Typography>
            <div className={classes.root}>
                <Tabs orientation="vertical" variant="fullWidth" value={activeTab} className={classes.tabs} onChange={(e, v) => setActiveTab(v)} >
                    <Tab label="Ε.Ε. 1" />
                    <Tab label="Ε.Ε. 2" />
                    <Tab label="Ε.Ε. 3" />
                    <Tab label="Ε.Ε. 4" />
                    <Tab label="Ε.Ε. 5" />
                    <Tab label="Ε.Ε. 6" />
                    <Tab label="Ε.Ε. 7" />
                </Tabs>
                <TabPanel value={activeTab} index={0}>
                    <TableContainer component={Paper}>
                        <Table className={classes.table}>
                            <TableBody>
                                <TableRow>
                                    <TableCell component="th" scope="row">Τίτλος Ενότητας Εργασίας</TableCell>
                                    <TableCell align="left">ΕΕ1 – Συλλογή, καταγραφή και κατηγοριοποίηση δειγμάτων από ελληνικές ποικιλίες ελιάς</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Kατηγορία Δραστηριότητας</TableCell>
                                    <TableCell align="left">ΒΙΕ: Βιομηχανική Έρευνα (Άρθρο 25)</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Υπεύθυνος Ε.Ε. (Φορέας)</TableCell>
                                    <TableCell align="left">ΒΙΟΕΛΛΑΣ</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Ανθρωπομήνες</TableCell>
                                    <TableCell align="left">98,00</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Έναρξη (μήνας)</TableCell>
                                    <TableCell align="left">18/7/2018</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Τέλος (μήνας)</TableCell>
                                    <TableCell align="left">17/3/2021</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </TabPanel>

                <TabPanel value={activeTab} index={1}>
                    <TableContainer component={Paper}>
                        <Table className={classes.table}>
                            <TableBody>
                                <TableRow>
                                    <TableCell component="th" scope="row">Τίτλος Ενότητας Εργασίας</TableCell>
                                    <TableCell align="left">ΕΕ2 – Ανάπτυξη, εφαρμογή και πιστοποίηση μεθοδολογιών για την ιχνηλασιμότητα των επιλεγμένων ποικιλιών ελιάς</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Kατηγορία Δραστηριότητας</TableCell>
                                    <TableCell align="left">ΒΙΕ: Βιομηχανική Έρευνα (Άρθρο 25)</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Υπεύθυνος Ε.Ε. (Φορέας)</TableCell>
                                    <TableCell align="left">ΕΚΕΤΑ</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Ανθρωπομήνες</TableCell>
                                    <TableCell align="left">47,00</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Έναρξη (μήνας)</TableCell>
                                    <TableCell align="left">18/8/2018</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Τέλος (μήνας)</TableCell>
                                    <TableCell align="left">17/3/2021</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </TabPanel>

                <TabPanel value={activeTab} index={2}>
                    <TableContainer component={Paper}>
                        <Table className={classes.table}>
                            <TableBody>
                                <TableRow>
                                    <TableCell component="th" scope="row">Τίτλος Ενότητας Εργασίας</TableCell>
                                    <TableCell align="left"> ΕΕ3 - Ανάπτυξη, εφαρμογή και πιστοποίηση μεθοδολογιών για την ταυτοποίηση της μεθόδου επεξεργασίας των επιλεγμένων ποικιλιών βρώσιμης ελιάς</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Kατηγορία Δραστηριότητας</TableCell>
                                    <TableCell align="left">ΒΙΕ: Βιομηχανική Έρευνα (Άρθρο 25)</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Υπεύθυνος Ε.Ε. (Φορέας)</TableCell>
                                    <TableCell align="left">ΤΦΧΦΠ</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Ανθρωπομήνες</TableCell>
                                    <TableCell align="left">88,00</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Έναρξη (μήνας)</TableCell>
                                    <TableCell align="left">18/10/2018</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Τέλος (μήνας)</TableCell>
                                    <TableCell align="left">17/7/2021</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </TabPanel>

                <TabPanel value={activeTab} index={3}>
                    <TableContainer component={Paper}>
                        <Table className={classes.table}>
                            <TableBody>
                                <TableRow>
                                    <TableCell component="th" scope="row">Τίτλος Ενότητας Εργασίας</TableCell>
                                    <TableCell align="left">ΕΕ4 - Ανάπτυξη, εφαρμογή και πιστοποίηση μεθοδολογιών για την τεκμηρίωση του ισχυρισμό υγείας στα συλλεγμένα δείγματα ελαιολάδου. Εύρεση βέλτιστων συνθηκών ελαιοποίησης και ανάπτυξη εξειδικευμένου πρωτοκόλλου παραγωγής ελαιολάδου</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Kατηγορία Δραστηριότητας</TableCell>
                                    <TableCell align="left">ΠΕΑ: Πειραματική Ανάπτυξη (Άρθρο 25)</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Υπεύθυνος Ε.Ε. (Φορέας)</TableCell>
                                    <TableCell align="left">ΤΦΧΦΠ</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Ανθρωπομήνες</TableCell>
                                    <TableCell align="left">54,00</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Έναρξη (μήνας)</TableCell>
                                    <TableCell align="left">18/12/2018</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Τέλος (μήνας)</TableCell>
                                    <TableCell align="left">17/7/2021</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </TabPanel>

                <TabPanel value={activeTab} index={4}>
                    <TableContainer component={Paper}>
                        <Table className={classes.table}>
                            <TableBody>
                                <TableRow>
                                    <TableCell component="th" scope="row">Τίτλος Ενότητας Εργασίας</TableCell>
                                    <TableCell align="left"> ΕΕ5 - Ανάπτυξη, εφαρμογή και πιστοποίηση μεθοδολογιών για την διασφάλιση ποιότητας των ΠΟΠ, ΠΓΕ ελαιολάδων</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Kατηγορία Δραστηριότητας</TableCell>
                                    <TableCell align="left"> ΒΙΕ: Βιομηχανική Έρευνα (Άρθρο 25)</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Υπεύθυνος Ε.Ε. (Φορέας)</TableCell>
                                    <TableCell align="left">Δημόκριτος</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Ανθρωπομήνες</TableCell>
                                    <TableCell align="left">45,00</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Έναρξη (μήνας)</TableCell>
                                    <TableCell align="left">18/7/2018</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Τέλος (μήνας)</TableCell>
                                    <TableCell align="left">17/7/2021</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </TabPanel>

                <TabPanel value={activeTab} index={5}>
                    <TableContainer component={Paper}>
                        <Table className={classes.table}>
                            <TableBody>
                                <TableRow>
                                    <TableCell component="th" scope="row">Τίτλος Ενότητας Εργασίας</TableCell>
                                    <TableCell align="left">ΕΕ6 - Ανάπτυξη και εφαρμογή συστημάτων ελέγχου ποιότητας στα παραγόμενα προϊόντα ελιάς</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Kατηγορία Δραστηριότητας</TableCell>
                                    <TableCell align="left">ΒΙΕ: Βιομηχανική Έρευνα (Άρθρο 25)</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Υπεύθυνος Ε.Ε. (Φορέας)</TableCell>
                                    <TableCell align="left">ΒΙΟΕΛΛΑΣ</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Ανθρωπομήνες</TableCell>
                                    <TableCell align="left">22,00</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Έναρξη (μήνας)</TableCell>
                                    <TableCell align="left">18/1/2021</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Τέλος (μήνας)</TableCell>
                                    <TableCell align="left">17/7/2021</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </TabPanel>

                <TabPanel value={activeTab} index={6}>
                    <TableContainer component={Paper}>
                        <Table className={classes.table}>
                            <TableBody>
                                <TableRow>
                                    <TableCell component="th" scope="row">Τίτλος Ενότητας Εργασίας</TableCell>
                                    <TableCell align="left">ΕΕ7 - Προβολή των πιστοποιημένων προϊόντων ελιάς και ελαιολάδου σε εμπορικές εκθέσεις του εξωτερικού</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Kατηγορία Δραστηριότητας</TableCell>
                                    <TableCell align="left">ΕΚΘΜΜΕ: Ενισχύσεις για συμμετοχή ΜΜΕ σε εμπορικές εκθέσεις (Άρθρο 19)</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Υπεύθυνος Ε.Ε. (Φορέας)</TableCell>
                                    <TableCell align="left">ΜΕΛΑΣ</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Ανθρωπομήνες</TableCell>
                                    <TableCell align="left">4,00</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Έναρξη (μήνας)</TableCell>
                                    <TableCell align="left">18/7/2018</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">Τέλος (μήνας)</TableCell>
                                    <TableCell align="left">17/7/2021</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </TabPanel>
            </div>

        </React.Fragment>
    )
}